<div class="section-container">
  <!-- <h2 class="company-info-title mat-headline">Company Information</h2> -->
  <div class="inputs-container">
    <div class="section company-name-section">
      <mat-form-field afloatLabel="always" appearance="outline">
        <mat-label>{{ "BranchPopup.CompanyName" | translate }}</mat-label>
        <input
          matInput
          [value]="(branchSelectionService.companyName$ | async) || ''"
          readonly
          [style.pointerEvents]="'none'"
        />
      </mat-form-field>
      <div
        *ngIf="branches.length > 1; else singleBranchField"
        class="branch-select-container"
      >
        <mat-form-field
          appearance="outline"
          class="full-width"
          [ngClass]="{
            'red-outline': !selectedBranch || selectedBranch === ''
          }"
        >
          <mat-label>{{ "BranchPopup.SelectBranch" | translate }}</mat-label>
          <mat-select
            [(ngModel)]="selectedBranch"
            (selectionChange)="onBranchChanged($event.value)"
          >
            <mat-option
              *ngFor="let branch of branches"
              [value]="branch.branchId"
            >
              {{ branch.branchName }} <br />
              {{ branch.addressCity }}, {{ branch.addressState }}
            </mat-option>
          </mat-select>
          <div
            *ngIf="!selectedBranch || selectedBranch === ''"
            style="color: red"
          >
            Please Select a Branch
          </div>
        </mat-form-field>
      </div>

      <ng-template #singleBranchField>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ "BranchPopup.BranchId" | translate }}</mat-label>
          <input
            matInput
            [value]="
              singleBranchInfo
                ? singleBranchInfo.addressCity +
                  ', ' +
                  singleBranchInfo.addressState
                : ''
            "
            readonly
            [style.pointerEvents]="'none'"
          />
        </mat-form-field>
      </ng-template>
    </div>
  </div>
</div>
